import type { JwtServiceInterface, JwtTokens } from '@wizbii-utils/angular/jwt';
import type { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { Store } from '@ngrx/store';
import { jwtDelete, jwtSet, jwtTokens } from '@wizbii-utils/angular/stores';
import { AuthenticationWebservice } from '@wizbii-utils/angular/webservices';
import { LocaleEnum } from '@wizbii/utils/models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JwtService implements JwtServiceInterface {
  blacklistRoutes: (string | RegExp)[];
  readonly #store = inject(Store);
  readonly #authService = inject(AuthenticationWebservice);
  readonly #router = inject(Router);

  constructor() {
    this.blacklistRoutes = [
      'https://storage.googleapis.com',
      environment.api.strapi,
      new RegExp(`${environment.api.authentication}(?!(/v1/user).*(/email|password|overview))`, 'i'),
    ];

    for (const locale of Object.values(LocaleEnum)) {
      const route = `${environment.api.account}/v2/country/${locale}`;
      this.blacklistRoutes.push(route);
    }
  }

  getTokens(): Observable<any> {
    return this.#store.select(jwtTokens).pipe(map((jwtState) => (!jwtState?.token ? null : jwtState)));
  }

  logout(): void {
    this.#store.dispatch(jwtDelete());
    void this.#router.navigate(['/']);
  }

  refreshToken(tokens: JwtTokens): Observable<JwtTokens> {
    return this.#authService.refreshTokenV2(tokens, environment.applicationId).pipe(
      map((newTokens) => {
        this.#store.dispatch(jwtSet({ jwtTokens: newTokens }));
        return newTokens;
      })
    );
  }

  saveLocalTokens(jwtTokens: JwtTokens): void {
    this.#store.dispatch(jwtSet({ jwtTokens }));
  }
}
